






























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import InteractiveModal from '@/components/base/InteractiveModal.vue';
import {
  CRITERION_TYPE_DISPLAY_NAME,
  CRITERION_TYPE,
  Criterion,
  BooleanCriterionContent,
  RangeCriterionContent,
  CheckboxesCriterionContent,
  CheckboxesSingleCriterionContent,
  ContinuousDiscreteCriterionContent,
} from '@/store/types/criterions.types';
import { StringInputOption } from '@/jbi-shared/types/form.types';
import {
  cloneDeep as _cloneDeep,
  isEqual as _isEqual,
  uniq as _uniq,
  merge as _merge,
} from 'lodash';
import { DialogProgrammatic as Dialog } from 'buefy';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import CheckboxesCriterionInput from '@/views/Project/components/CheckboxesCriterionInput.vue';
import BooleanCriterionInput from '@/views/Project/components/BooleanCriterionInput.vue';
import RangeCriterionInput from '@/views/Project/components/RangeCriterionInput.vue';
import ContinuousDiscreteCriterionInput from '@/views/Project/components/ContinuousDiscreteCriterionInput.vue';
import { CplusCriteria } from '@/store/modules/projects/types/projects.types';
import ConfirmationDialogue from '../../../components/ConfirmationDialogue.vue';
import UnavailableCyclesDialogue from './UnavailableCyclesDialogue.vue';
import { AuditDetail } from '@/store/modules/audits/types/audits.types';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import {
  AuditAvailabilityForCriteriaUpdate,
  GetFilteredAuditsByCriteriaPayload,
} from '@/store/modules/projects/types/projects.types';
import { ApiState, Pagination } from '@/store/types/general.types';
import BasePagination from '@/components/base/BasePagination.vue';

@Component({
  components: {
    CheckboxesCriterionInput,
    BooleanCriterionInput,
    RangeCriterionInput,
    ValidationProvider,
    ValidationObserver,
    ContinuousDiscreteCriterionInput,
    InteractiveModal,
    BasePagination,
  },
})
export default class AuditCriteriaCreateModal extends Vue {
  @Prop()
  public modalTitle!: string;

  @Prop({
    default() {
      return new Criterion({
        content: new BooleanCriterionContent({
          title: '',
          type: CRITERION_TYPE.BOOLEAN,
          sourceLink: '',
        }),
      });
    },
  })
  public criterion!: Criterion;

  @Prop()
  public reOrderedCriteriaArray!: any;

  @Prop()
  public criteriaIndex!: number;

  @Prop({
    default() {
      return false;
    },
  })
  public isSavedCriteria!: boolean;

  @Prop()
  public currentCriteria!: CplusCriteria;

  @Prop({ default: true })
  public projectEdit!: boolean;

  @Prop()
  public createProject!: boolean;

  @Prop()
  public isProject!: boolean;

  @Prop({ default: false })
  public isMinimized!: boolean;

  @Prop({ default: true })
  public isModalActive!: boolean;

  @Prop()
  public projectId!: number;

  @Prop()
  public auditId!: number;

  @Action('projects/getAvailableFilteredAudits')
  public getAvailableFilteredAudits!: (
    payload: GetFilteredAuditsByCriteriaPayload,
  ) => void;

  @State((state: RootState) => state.projects.availableAudits)
  public availableAudits!: Pagination<AuditDetail>;

  @State(
    (state: RootState) => state.projects.apiState.getAvailableFilteredAudits,
  )
  public availableAuditsApiState!: ApiState;

  public dirtyCriterion = _cloneDeep(this.criterion);
  public dirtyCriterions!: any;

  public selectedAuditIds: number[] = [];
  public displayedAudits: AuditDetail[] = [];
  public currentPageAudits: AuditDetail[] = [];

  public checkboxKey: number = Math.floor(Math.random() * 999);

  public hasRangeError: boolean = false;
  public hasBooleanError: boolean = false;
  public isBtnDisabled: boolean = true;
  public applyChanges: boolean = false;

  public filter!: AuditAvailabilityForCriteriaUpdate;
  public perPage: number = 10;
  public page: number = 1;
  public totalCount: number = 0;
  public visitedPages: Set<number> = new Set();

  get totalNumberOfPage(): number {
    return Math.ceil(this.getTotalCount / this.perPage);
  }

  get startItemIndex(): number {
    return this.page * this.perPage - this.perPage + 1;
  }

  get endItemIndex(): number {
    return Math.min(this.getTotalCount, this.page * this.perPage);
  }

  get isFirstPage(): boolean {
    return this.page === 1;
  }

  get isLastPage(): boolean {
    return this.page === this.totalNumberOfPage;
  }

  get getCurrentPage(): number {
    return this.page;
  }

  get getTotalCount(): number {
    if (!this.availableAudits) {
      return 0;
    }
    return this.availableAudits.totalItems != null
      ? this.availableAudits.totalItems
      : 0;
  }

  get CRITERION_TYPE() {
    return CRITERION_TYPE;
  }

  set getCurrentPage(newValue: number) {
    this.page = Number(newValue);
    // Fetch new page data instead of slicing the Pagination object
    if (this.applyChanges) {
      const params: GetFilteredAuditsByCriteriaPayload = {
        projectId: this.projectId,
        criterionId: this.criterion.id!,
        filter: AuditAvailabilityForCriteriaUpdate.AVAILABLE,
        limit: this.perPage,
        page: this.page,
        // If we are editing the current audit, include its id in the payload
        currentAuditId: this.isProject ? undefined : this.auditId,
      };
      this.getAvailableFilteredAudits(params);
    }
  }

  get getCurrentPerPage(): number {
    return this.perPage;
  }

  /**
   * Computed properties for content type checking
   * IMPROVEMENTS:
   * 1. Extracted conditional logic from the template to computed properties
   * 2. Improves readability and maintainability of the template
   * 3. Enables easier testing and reuse of the conditions
   */
  get isBooleanContent(): boolean {
    return this.dirtyCriterion.content.type === CRITERION_TYPE.BOOLEAN;
  }

  get isRangeContent(): boolean {
    return this.dirtyCriterion.content.type === CRITERION_TYPE.RANGE;
  }

  get isCheckboxesContent(): boolean {
    return (
      this.dirtyCriterion.content.type === CRITERION_TYPE.CHECKBOXES ||
      this.dirtyCriterion.content.type === CRITERION_TYPE.CHECKBOXES_SINGLE
    );
  }

  get isContinuousDiscreteContent(): boolean {
    return (
      this.dirtyCriterion.content.type === CRITERION_TYPE.CONTINUOUS_DISCRETE
    );
  }

  get options(): StringInputOption[] {
    return Object.entries(CRITERION_TYPE_DISPLAY_NAME).map(([key, value]) => {
      return {
        id: key,
        name: value,
      };
    });
  }

  get isAuditSelectionMissing(): boolean {
    return (
      this.applyChanges &&
      this.selectedAuditIds.length === 0 &&
      this.hasAnySelectableAudits
    );
  }

  /**
   * Determines if there are any selectable audits that are not the current audit.
   * If the total count is 0, this will return false.
   * If the total count is greater than 1, this will return true.
   * If the total count is 1, this will check if the single item is not the current audit
   * If the items have not been loaded yet, this will return false.
   */
  get hasAnySelectableAudits(): boolean {
    const total = this.getTotalCount;
    if (total === 0) {
      return false;
    }
    if (total > 1) {
      return true;
    }

    // If total is 1, we must check if that single item is the current audit.
    // We can only do this if the item has been loaded from the API.
    const items = this.availableAudits.items;
    if (items && items.length === 1) {
      return items[0].id !== this.auditId;
    }

    // Default to false if the check can't be completed (e.g., items not loaded yet).
    return false;
  }

  public reset() {
    this.dirtyCriterion = _cloneDeep(this.criterion);
  }

  public async addCriterion(): Promise<boolean> {
    if (!(await this.validatePreSave())) {
      return false;
    }
    const dirtyCriterion = this.sanitizeCriterion(this.dirtyCriterion);
    if (dirtyCriterion.content instanceof CheckboxesCriterionContent) {
      const [first, ...rest] = dirtyCriterion.content.checkboxesOptions;
      dirtyCriterion.content.checkboxesOptions = [...rest, first];
    }
    this.$emit('newCriteria', {
      id: '',
      ...dirtyCriterion.content,
    });
    return true;
  }

  public async editCriterion(): Promise<void> {
    if (!(await this.validatePreSave())) return;

    const isProjectEdit = this.projectEdit;

    const modalTitle = isProjectEdit
      ? 'Confirm Changes?'
      : 'Are you sure you want to customise this criteria?';

    const confirmationText = isProjectEdit
      ? 'You have selected to save changes to subsequent data collections. This action cannot be undone.'
      : 'Customising this criteria will archive the previous version and disable any further data collection against it. You cannot undo this action.';

    this.$buefy.modal.open({
      parent: this,
      component: ConfirmationDialogue,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle,
        confirmationText,
      },
      events: {
        confirm: () => this.updateCriterion(),
      },
    });
  }

  public updateCriterion() {
    const dirtyCriterion = this.sanitizeCriterion(this.dirtyCriterion);
    const updatedDirtyCriterion: CplusCriteria = this.updateDirtyCplusCriteria(
      this.dirtyCriterions[this.criteriaIndex],
      dirtyCriterion.content,
    );
    if (this.createProject) {
      this.dirtyCriterions[this.criteriaIndex] = { ...updatedDirtyCriterion };
      this.dirtyCriterions[this.criteriaIndex].isChanged = true;
      this.$emit('updateReOrderedCriteriaArray', this.dirtyCriterions);
    } else {
      this.dirtyCriterions[this.criteriaIndex] = { ...updatedDirtyCriterion };
      this.dirtyCriterions[this.criteriaIndex].isChanged = true;
      this.$emit('updateCriteria', {
        newValue: this.dirtyCriterions[this.criteriaIndex],
        applyChanges: this.applyChanges,
        // Include current auditId if editing current audit
        selectedAuditIds: this.isProject
          ? this.selectedAuditIds
          : Array.from(new Set([...this.selectedAuditIds, this.auditId])),
        projectId: this.projectId,
      });
    }
  }

  public async validatePreSave() {
    // check duplicated checkboxed options
    if (
      this.dirtyCriterion.content instanceof CheckboxesCriterionContent ||
      this.dirtyCriterion.content instanceof CheckboxesSingleCriterionContent
    ) {
      const { checkboxesOptions } = this.dirtyCriterion.content;
      const sanitized = this.sanitizeCriterionCheckboxesOptions(
        checkboxesOptions,
      );
      if (!_isEqual(checkboxesOptions, sanitized)) {
        const confirm = () =>
          new Promise((resolve) => {
            return Dialog.confirm({
              message: `Empty values and duplicated values will be removed.`,
              confirmText: 'Confirm',
              cancelText: 'Cancel',
              onConfirm() {
                resolve(true);
              },
              onCancel() {
                resolve(false);
              },
            });
          });
        if (!(await confirm())) {
          return false;
        }
      }
    }
    if (this.dirtyCriterion.content instanceof RangeCriterionContent) {
      if (
        Number(this.dirtyCriterion.content.range[1]) <=
        Number(this.dirtyCriterion.content.range[0])
      ) {
        return false;
      }
    }
    return true;
  }

  public sanitizeCriterion(criterion: Criterion): Criterion {
    criterion = _cloneDeep(criterion);
    if (criterion.content instanceof RangeCriterionContent) {
      criterion.content.range = [
        Number(criterion.content.range[0]),
        Number(criterion.content.range[1]),
        String(criterion.content.range[2]),
      ];
    } else if (
      criterion.content instanceof CheckboxesCriterionContent ||
      criterion.content instanceof CheckboxesSingleCriterionContent
    ) {
      criterion.content.checkboxesOptions = this.sanitizeCriterionCheckboxesOptions(
        criterion.content.checkboxesOptions,
      );
    }
    return criterion;
  }

  public sanitizeCriterionCheckboxesOptions(arr: string[]) {
    arr = arr.map((s) => String(s).trim()).filter(Boolean);
    arr = _uniq(arr);
    return arr;
  }

  public updateDirtyCplusCriteria(
    dirtyCriteria: CplusCriteria,
    updatedCriteria: any,
  ): CplusCriteria {
    // Iterate through the object keys of the existing object
    Object.keys(dirtyCriteria).forEach((item: keyof CplusCriteria) => {
      // Find the matched key value from the updatedCriteria
      const matchedObjectKeys = Object.keys(updatedCriteria).find(
        (data: any) => data === item,
      );

      if (matchedObjectKeys) {
        // Update key value from existing object with the updatedCriteria value
        dirtyCriteria[item] = updatedCriteria[item];
      }
      if (
        this.dirtyCriterion.content.type === CRITERION_TYPE.CONTINUOUS_DISCRETE
      ) {
        dirtyCriteria.config = updatedCriteria.config;
        dirtyCriteria.continuousDiscreteOptions =
          updatedCriteria.continuousDiscreteOptions;
      }
    });
    return dirtyCriteria;
  }

  public openIneligibleDataCollectionPeriods() {
    this.$buefy.modal.open({
      parent: this,
      component: UnavailableCyclesDialogue,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Unavailable Data Collection Periods',
        projectId: this.projectId,
        criterionId: this.criterion.id!,
        confirmationButtonText: 'OK',
      },
    });
  }

  public disableRangeSubmit(value: boolean) {
    return (this.hasRangeError = value);
  }

  public disableBooleanSubmit(value: boolean) {
    return (this.hasBooleanError = value);
  }

  @isDifferent
  @Watch('dirtyCriterion.content.type')
  public onTypeChange(type: CRITERION_TYPE) {
    switch (type) {
      case CRITERION_TYPE.BOOLEAN:
        this.dirtyCriterion.content = new BooleanCriterionContent(
          this.dirtyCriterion.content,
        );
        if (!this.isNew) {
          this.dirtyCriterions[this.criteriaIndex].booleanOptions = [];
        }
        break;
      case CRITERION_TYPE.RANGE:
        this.dirtyCriterion.content = new RangeCriterionContent({
          ...this.dirtyCriterion.content,
        });
        if (!this.isNew) {
          this.dirtyCriterions[this.criteriaIndex].range = [];
        }
        break;
      case CRITERION_TYPE.CHECKBOXES:
        this.dirtyCriterion.content = new CheckboxesCriterionContent({
          ...this.dirtyCriterion.content,
        });
        if (!this.isNew) {
          this.dirtyCriterions[this.criteriaIndex].checkboxesOptions = [];
        }
        break;
      case CRITERION_TYPE.CHECKBOXES_SINGLE:
        this.dirtyCriterion.content = new CheckboxesSingleCriterionContent({
          ...this.dirtyCriterion.content,
        });
        if (!this.isNew) {
          this.dirtyCriterions[this.criteriaIndex].checkboxesOptions = [];
        }
        break;
      case CRITERION_TYPE.CONTINUOUS_DISCRETE:
        this.dirtyCriterion.content = new ContinuousDiscreteCriterionContent({
          ...this.dirtyCriterion.content,
        });
        break;
    }
  }

  @Watch('dirtyCriterion', { deep: true })
  public isCriteriaEdited(): void {
    this.isBtnDisabled =
      JSON.stringify(this.dirtyCriterion) !== JSON.stringify(this.criterion)
        ? false
        : true;
  }

  @Watch('applyChanges')
  onApplyChangesChange(newValue: boolean) {
    // If the checkbox is checked, fetch the filtered audits.
    if (newValue) {
      this.selectedAuditIds = [];
      this.visitedPages.clear();
      const params: GetFilteredAuditsByCriteriaPayload = {
        projectId: this.projectId,
        criterionId: this.criterion.id!,
        filter: AuditAvailabilityForCriteriaUpdate.AVAILABLE,
        limit: this.perPage,
        page: this.page,
        // If we are editing the current audit, include its id in the payload
        // This id will be used to filter out the current audit from the available audits list
        currentAuditId: this.isProject ? undefined : this.auditId,
      };
      this.getAvailableFilteredAudits(params);
    }
  }

  /**
   * This watcher listens for changes in the availableAuditsApiState.
   * When the API call is successful and the available audits are loaded,
   * it updates the currentPageAudits and displayedAudits with the
   * fetched items.
   * It also handles the initial auto-selection of audits on the first
   * page load.
   * The auto-selection is done only once per page to avoid re-selecting
   * audits when the user navigates back to a previously visited page.
   */
  @Watch('availableAuditsApiState', { deep: true })
  public onApiStateChange(state: ApiState) {
    if (state.success && this.availableAudits.items) {
      this.currentPageAudits = this.availableAudits.items;
      this.displayedAudits = this.availableAudits.items;
      this.checkboxKey += 1;

      // Only perform the "auto-select all audits" on the initial load
      if (!this.visitedPages.has(this.page)) {
        const selectableAuditIdsOnNewPage = this.availableAudits.items.map(
          (audit) => audit.id,
        );

        const updatedSelectedIds = new Set([
          ...this.selectedAuditIds,
          ...selectableAuditIdsOnNewPage,
        ]);

        this.selectedAuditIds = Array.from(updatedSelectedIds);

        // Set flag to false after initial load is handled
        this.visitedPages.add(this.page);
      }
    }
  }

  public get checkedAll(): boolean {
    if (!this.currentPageAudits || this.currentPageAudits.length === 0) {
      return false;
    }

    const selectableIdsOnPage = this.currentPageAudits.map((audit) => audit.id);

    return selectableIdsOnPage.every((id) =>
      this.selectedAuditIds.includes(id),
    );
  }

  get isNew() {
    return this.criteriaIndex !== undefined ? false : true;
  }

  public mounted() {
    this.dirtyCriterions = _cloneDeep(this.reOrderedCriteriaArray);
  }

  public getFormattedText(value: string) {
    const lowerCaseValue = value.toLowerCase();
    return lowerCaseValue.charAt(0).toUpperCase() + lowerCaseValue.slice(1);
  }

  /**
   * Toggles the selection of all audits on the current page.
   * If the user checks the box, all current page audits are added to the selected list.
   * If the user unchecks the box, all current page audits are removed from the selected list.
   */
  public toggleSelectAllAudits(toggle: boolean): void {
    const currentAuditIds: number[] = this.currentPageAudits.map(
      (cpa) => cpa.id,
    );

    if (toggle) {
      this.selectedAuditIds.push(...currentAuditIds);
      this.selectedAuditIds = [...new Set(this.selectedAuditIds)];
      return;
    }

    this.selectedAuditIds = this.selectedAuditIds.filter(
      (id) => !currentAuditIds.includes(id),
    );
  }

  get showSourceLinkInput(): boolean {
    return !(
      this.currentCriteria &&
      this.currentCriteria.document &&
      this.currentCriteria.document.id !== ''
    );
  }

  get sourceLink() {
    const pattern = /^((http|https|ftp):\/\/)/;
    if (
      this.dirtyCriterion.content.sourceLink &&
      !pattern.test(this.dirtyCriterion.content.sourceLink)
    ) {
      return 'http://' + this.dirtyCriterion.content.sourceLink;
    } else {
      return this.dirtyCriterion.content.sourceLink;
    }
  }

  /**
   * Handler methods for click events
   * IMPROVEMENTS:
   * 1. Extracted inline template code to dedicated methods
   * 2. Improves readability of the template
   * 3. Enables better testing and reuse
   * 4. Following the principle of separation of concerns
   */
  public handleCreateClick(validator: any): void {
    validator.validate().then((validated: boolean) => {
      if (validated === false) return;
      this.addCriterion();
    });
  }

  public handleEditClick(validator: any): void {
    validator.validate().then((validated: boolean) => {
      if (validated === false) return;
      this.editCriterion();
    });
  }

  /**
   * Type-safe accessors for different criterion content types
   * These computed properties properly cast the content object to specific types
   * which lets TypeScript recognize the properties that exist on each content type
   */
  get booleanOptions(): [string, string, string] {
    return (this.dirtyCriterion.content as BooleanCriterionContent)
      .booleanOptions;
  }

  set booleanOptions(value: [string, string, string]) {
    (this.dirtyCriterion
      .content as BooleanCriterionContent).booleanOptions = value;
  }

  get rangeOptions(): [number, number, string] {
    return (this.dirtyCriterion.content as RangeCriterionContent).range;
  }

  set rangeOptions(value: [number, number, string]) {
    (this.dirtyCriterion.content as RangeCriterionContent).range = value;
  }

  get checkboxesOptions(): string[] {
    return (this.dirtyCriterion.content as CheckboxesCriterionContent)
      .checkboxesOptions;
  }

  set checkboxesOptions(value: string[]) {
    (this.dirtyCriterion
      .content as CheckboxesCriterionContent).checkboxesOptions = value;
  }

  get areAllAuditsSelected(): boolean {
    return (
      this.selectedAuditIds.length > 0 &&
      this.selectedAuditIds.length === this.currentPageAudits.length
    );
  }

  /**
   * Computed property to safely expose criterion title to InteractiveModal.
   * Prevents "Avoid mutating prop directly" Vue warnings by creating
   * an intermediary between component data and child prop.
   */
  get criterionTitle(): string {
    return this.dirtyCriterion.content.title;
  }

  get isFormDirty(): boolean {
    return (
      JSON.stringify(this.criterion) !== JSON.stringify(this.dirtyCriterion)
    );
  }
}
